export const contactServiceOptions = [
  "VPS Hosting",
  "Dedicated Server",
  "Cloud Solution",
  "Business Email",
  "Security & Network",
  "Custom Infrastructure",
  "Billing or Support",
] as const;
